const coverage = {
  full: ['hotel', 'room', 'other'],
  static: ['hotel', 'room'],
  catalog: ['room'],
  recent: ['other'],
  future: ['other'],
  ari: ['other'],
}

function timestamp(value) {
  if (!value) return null
  const normalized = String(value).trim().replace(' ', 'T')
  const zoned = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized) ? normalized : `${normalized}+08:00`
  const result = Date.parse(zoned)
  return Number.isFinite(result) ? result : null
}

export function resourceActivityRows(row) {
  const rows = [
    { key: 'hotel', label: '酒店', at: row.last_hotel_push_at, status: row.last_hotel_push_status, error: row.last_hotel_push_error },
    { key: 'room', label: '房型/价格', at: row.last_room_push_at, status: row.last_room_push_status, error: row.last_room_push_error },
    { key: 'other', label: '房态/条款', at: row.last_other_push_at, status: row.last_other_push_status, error: row.last_other_push_error },
  ]
  const scope = row.last_resource_check_scope
  const covered = coverage[scope] || []
  return rows.map(item => {
    const saved = (row.resource_check_results || {})[item.key]
    const scan = saved || (covered.includes(item.key) ? { scope, checked_at: row.last_resource_checked_at, status: row.last_resource_check_status, error: row.last_resource_check_error } : null)
    if (!scan || !(coverage[scan.scope] || []).includes(item.key) || !['success', 'unchanged', 'deferred', 'failed'].includes(scan.status)) return item
    const checkedAt = timestamp(scan.checked_at)
    const evidenceAt = timestamp(item.at)
    if (checkedAt === null || (item.at && (evidenceAt === null || evidenceAt > checkedAt))) return item
    return {
      ...item,
      at: scan.checked_at,
      status: scan.status,
      error: scan.error || '',
      evidence_at: item.at || null,
      evidence_status: item.status || null,
      checked_scope: scan.scope,
    }
  })
}
